const SPECIAL_CHARACTERS = '!@#$%^'
const MIN_PASSWORD_LENGTH = 6

const passwordDescription =
  'Password must contain at least one uppercase letter, at least one digit, at least one special character (' +
  SPECIAL_CHARACTERS +
  '), and be at least six characters in length.'

const passwordRegEx =
  '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[' + SPECIAL_CHARACTERS + ']).{6,}$'

/**
 * Generate random string based on length
 *
 * @param length
 */
const generateRandomString = (length: number): string => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789' +
    SPECIAL_CHARACTERS
  const charactersLength = characters.length
  let result = ''
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const ProfileManagement = {
  MIN_PASSWORD_LENGTH,
  SPECIAL_CHARACTERS,
  passwordDescription,
  passwordRegEx,
  generateRandomString,
}
